import { FormValues } from '../models/employeeData.model';
import { ComplianceTaskListModel } from '../models/complianceTaskListModel';

// Current user

export interface IEmployeeData {
    type: 'EMPLOYEE_DATA',
    user: FormValues
}
export function getEmployeeData(user: FormValues): IEmployeeData {
    return { type: 'EMPLOYEE_DATA', user: user }
}

//---------------------------------------------------------------------



// Save all reports

export interface ISearchReports {
    type: 'REPORTS_COLLECTION',
    tasks: ComplianceTaskListModel
}
export function getSearchReports(reports: ComplianceTaskListModel): ISearchReports {
    return { type: 'REPORTS_COLLECTION', tasks: reports }
}

//---------------------------------------------------------------------
